import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {SearchResultsDescription} from 'src/app/types/SearchResultsDescription';
import {SearchResultContent} from '../../../../types/SearchResultContent';

@Component({
  selector: 'app-search-short-description-v2',
  templateUrl: './search-short-description-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchShortDescriptionV2Component {
  count = input<number>(0);
  pluralName = input<string>();
  searchDescription = input<SearchResultsDescription>();
  searchResultContent = input<SearchResultContent>();
  scrollDownClicked = output<boolean>();

  public title = computed(() => (this.searchDescription() ? this.searchDescription().title : null));
  public name = computed(() => {
    if (this.searchResultContent()) {
      const names: string[] = [];
      if (this.searchResultContent().caregiverUnitType) {
        names.push(this.searchResultContent().caregiverUnitType.name);
      }
      if (this.searchResultContent().careServiceType) {
        names.push(this.searchResultContent().careServiceType.name);
      }
      if (this.searchResultContent().symptom) {
        names.push(this.searchResultContent().symptom.name);
      }
      return names.join(' och ');
    }
  });
  public place = computed(() => (this.searchResultContent() ? this.searchResultContent().place?.name : null));

  public scrollDownClick(): void {
    this.scrollDownClicked.emit(true);
  }
}
